// source: pbtypes/gen/waypoints/landing_pad_anchor_pose_source.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.waypoints.LandingPadAnchorPoseSource', null, global);
goog.exportSymbol('proto.waypoints.LandingPadAnchorPoseSource.Enum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.waypoints.LandingPadAnchorPoseSource = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.waypoints.LandingPadAnchorPoseSource, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.waypoints.LandingPadAnchorPoseSource.displayName = 'proto.waypoints.LandingPadAnchorPoseSource';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.waypoints.LandingPadAnchorPoseSource.prototype.toObject = function(opt_includeInstance) {
  return proto.waypoints.LandingPadAnchorPoseSource.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.waypoints.LandingPadAnchorPoseSource} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.waypoints.LandingPadAnchorPoseSource.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.waypoints.LandingPadAnchorPoseSource}
 */
proto.waypoints.LandingPadAnchorPoseSource.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.waypoints.LandingPadAnchorPoseSource;
  return proto.waypoints.LandingPadAnchorPoseSource.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.waypoints.LandingPadAnchorPoseSource} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.waypoints.LandingPadAnchorPoseSource}
 */
proto.waypoints.LandingPadAnchorPoseSource.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.waypoints.LandingPadAnchorPoseSource.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.waypoints.LandingPadAnchorPoseSource.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.waypoints.LandingPadAnchorPoseSource} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.waypoints.LandingPadAnchorPoseSource.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.waypoints.LandingPadAnchorPoseSource.Enum = {
  INVALID: 0,
  NAV: 1,
  STRICT_WORLD_FRAME_FILTER: 2,
  USER_PROVIDED_NAV: 3,
  NAV_CAM_POSE_GRAPH: 4,
  SITE_BASED_GPS: 5,
  DOCK_WAYPOINT_TEGRA_REBOOT: 6,
  DOCK_WORLD_WAYPOINT_TEGRA_REBOOT: 7,
  FUSED_VIO_GPS_ESTIMATOR: 8,
  LAST_CONVERGED_WORLD_FRAME_FILTER: 9,
  LANDING_PAD_DETECTION: 10
};

goog.object.extend(exports, proto.waypoints);
